module.exports = __webpack_public_path__ + "static/media/icon_star_green.488ef37e.svg";